import React from "react";

//Local Libraries
import phrasebookLoad from "../../../i18n";
import { gisRoutes } from "../../../routes/routes";
import * as token from '../../../helpers/token';
import { accountTypesConstants } from '../../../constants';
import { notificationActions } from '../../../actions';
import { userStorage } from '../../../helpers/user-storage';
import { history } from 'helpers';


//Components
import { SubmitButton } from "../../../components/SkyFramework/Buttons";
import { Form } from "../../../components/SkyFramework/Forms";
import { connect } from "react-redux";
// Constants
const phrasebook = phrasebookLoad()

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      functionality_id: 800,
      notification_title: undefined,
      notification_message: undefined,
      creator_customer_id: userStorage.getUser() && userStorage.getUser().customer_id ? userStorage.getUser().customer_id : undefined,
      creator_account_id: userStorage.getUser() && userStorage.getUser().id ? userStorage.getUser().id : undefined,
      receiver_account_id: undefined,
      notification_status: "requested",
      hasError: false
    }
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.account_type_logged = accountTypesConstants[token.loggedAccountType()];
  }

  componentDidCatch(error, info) {
    // Display fallback UI in case error occurs
    console.log(error);
    this.setState({ hasError: true });
    // You can also log the error to an error reporting service
  }

  handleChange(e) {
    const { id, name, value } = e.target;
    if (id) this.setState({ [id]: value });
    else if (name) this.setState({ [name]: value });
  }

  handleSubmit(e) {
    e.preventDefault();
    this.setState({ submitted: true });
    var newValues = {
      notification_title: this.state.notification_title,
      notification_message: this.state.notification_message,
      functionality_id: this.state.functionality_id,
      creator_customer_id: this.state.creator_customer_id,
      creator_account_id: this.state.creator_account_id,
      receiver_account_id: this.state.receiver_account_id,
      notification_status: this.state.notification_status
    }
    // if (token.loggedAccountType())
    this.props.dispatch(notificationActions.add(newValues));
  }

  backToSave(e) {
    history.push(gisRoutes.dashboard[e.target.id]);
    window.location.reload(false);
  }

  FormProfile = () => {
    const titleOptions = [{ value: 'Order Issue', label: 'Order Issue' }, { value: 'Portal Issue', label: 'Portal Issue' }, { value: 'Other', label: 'Other' }];
    const inputs = [
      { label: phrasebook.common.title, type: "select", id: "notification_title", name: "notification_title", options: titleOptions, selected: this.state.notification_title, empty_option: true },
      {
        label: phrasebook.support.ticket_details, type: "textarea", placeholder: "Describe your request",
        id: "notification_message", name: "notification_message", value: this.state.notification_message, details: phrasebook.common.max_250_words
      }
    ]

    const buttons = [<button className="btn btn-faded" id={this.account_type_logged} onClick={this.backToSave}>Back to Save!</button>, <SubmitButton title={phrasebook.common.add} />]
    return (
      <Form
        handleSubmit={this.handleSubmit}
        onChange={this.handleChange}
        title={phrasebook.support.report_issue}
        inputs={inputs}
        buttons={buttons}
      />)
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return <div class="container-xs">
        <div class="box p-1 p-sm-3 p-lg-3 text-center">
          <div class="rich-icon">
            <img src="https://skyframework.pccwglobal.com/img/error.svg" />
          </div>
          <h3>{phrasebook.common.error500}</h3>
          <p class="mb-2">{phrasebook.common.error500_description}</p>
        </div>
        {this.FormProfile()}

      </div>
    }
    return this.props.children;
  }
}

function mapStateToProps(state) {
  const { authentication, loggedpermissions } = state;
  const { authUser } = authentication;
  return {
    authUser,
    loggedpermissions
  };
}


export default (connect(mapStateToProps)(ErrorBoundary));
